import { useState } from "react";
import Grid from '@mui/material/Grid';
import CollectionsIcon from '@mui/icons-material/Collections';
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../components/Dialog/DiaCompMedium";
import Tooltip from '@mui/material/Tooltip';



export default function DiaImageRecord({incident_images, colorIcon}) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
    <Grid container sx={{pl:4, display:'flex', justifyContent:'flex-start', }}>

         <Tooltip title="Records / Images" placement="right">
            <IconButton onClick={handleOpen} color={colorIcon} aria-label="add an alarm">
                <CollectionsIcon fontSize="small" sx={{ }}/>
            </IconButton>   
        </Tooltip>
       
    </Grid>
    

    <CustomDialog open={open} onClose={handleClose}

         title="Records"
          
          content = {incident_images }

        />
        
</>
)}